import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import {
  AddEventTypeInDatabase,
} from "../../CrudOperations/PostOperation";
import { UpdateEventType } from "../../CrudOperations/Update&Edit";

const AddEventType = ({ closeModal, onSubmit, Staff, onUpdate }) => {





  const [EventType, setEventType] = useState(Staff ? Staff.EventTypeName : "");


  const handleFormSubmit = async (e) => {
    e.preventDefault();

    if (!Staff) { 



      const response = await AddEventTypeInDatabase(
        EventType
      );
      console.log(response);
  
      if (response.data.ServerMessage === "EventType added successfully.") {
        onSubmit(); // Handle new data
      }
      else{
        toast.error(response.data.ServerMessage);
      }
  

      





    }
    else{




      const response = await UpdateEventType(
        EventType,
        Staff.EventTypeId
      );
      console.log(response);
  
      if (response?.data?.ServerMessage ===  "EventType updated successfully.") {
        onSubmit(); // Handle new data
      }
      else{
        toast.error(response?.data?.ServerMessage);
      }
  
  







    }


















  };

  return (
    (
      <div
        className={`fixed inset-0 flex items-center justify-center bg-gray-500 bg-opacity-75 ${"block"}`}
      >
        <div className="bg-white rounded-lg p-4 w-1/3 shadow-lg">
          <h2 className="text-lg font-bold mb-3">
            {Staff ? "Edit Event" : "Add Event"}
          </h2>
          <form onSubmit={handleFormSubmit}>


            <div className="mb-2">
              <label className="block text-gray-700">Event Type *</label>
              <input
                type="text"
                value={EventType}
                onChange={(e) => setEventType(e.target.value)}
                className="border border-gray-300 p-1 w-full rounded-md"
              />
            </div>









            <div className="flex justify-end">
              <button
                type="button"
                onClick={closeModal}
                className="bg-gray-300 px-3 py-1 rounded-md mr-2"
              >
                Cancel
              </button>

              <button
                type="submit"
                className="bg-blue-600 text-white px-3 py-1 rounded-md"
              >
                {Staff ? "Update" : "Submit"}
              </button>
            </div>
          </form>
        </div>
      </div>
    )
  );
};

export default AddEventType;
